import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import { primary } from 'view/theme/colors';

export const StyledPlan = styled(Box)`
  border-radius: 1rem;
  border: 2px solid ${primary};
  padding: 1rem;
`;
